import { render } from "./Floor.vue?vue&type=template&id=fbc8d50c&scoped=true&bindings={\"floorName\":\"props\",\"backToLift\":\"options\"}"
import script from "./Floor.vue?vue&type=script&lang=js"
export * from "./Floor.vue?vue&type=script&lang=js"

import "./Floor.vue?vue&type=style&index=0&id=fbc8d50c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-fbc8d50c"

export default script